module.exports = __webpack_public_path__ + "static/media/spicy-mama-hero-desktop-ont-man.cede7c4d.jpg";